import { render, staticRenderFns } from "./IconContractList.vue?vue&type=template&id=2a67d6bf"
import script from "./IconContractList.vue?vue&type=script&lang=js"
export * from "./IconContractList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports